import React from "react";
import PublicShell from "../../components/PublicShell";
import usePageSeo from "../../lib/seo";

export default function About() {
  usePageSeo({
    title: "Sobre a Azuhomes",
    description: "Administração de casas próprias em Pernambuco, com curadoria, manutenção e atendimento internos.",
    path: "/sobre",
  });
  return (
    <PublicShell>
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-24">
        <span className="text-[11px] uppercase tracking-[0.28em] text-[#066B63]">Sobre a Azuhomes</span>
        <h1 className="font-display text-5xl text-[#0AA89C] mt-3 leading-tight">
          Uma empresa dedicada à administração das próprias casas de temporada.
        </h1>
        <div className="mt-10 space-y-5 text-[#22302E] leading-relaxed text-base">
          <p>
            A Azuhomes administra casas próprias em quatro destinos de Pernambuco: Praia dos Carneiros e
            Tamandaré, no litoral sul; Gravatá, na região serrana do agreste; e Recife. O modelo de trabalho
            é integrado — a mesma equipe é responsável pela curadoria dos imóveis, pela manutenção, pelo
            atendimento aos hóspedes e pela gestão financeira de cada reserva.
          </p>
          <p>
            Optamos por manter um portfólio enxuto para preservar o padrão de qualidade que consideramos
            adequado. Cada casa é preparada individualmente antes de cada chegada, com protocolos próprios
            de limpeza, checagem de utensílios e conferência de itens de conveniência.
          </p>
          <p>
            Ao efetuar a reserva diretamente pelo nosso site, o hóspede tem contato direto com a nossa
            equipe operacional. Não há intermediários e não incidem taxas adicionais além das que estão
            descritas no momento da reserva. A confirmação da disponibilidade é feita em tempo real, e o
            pagamento é processado pelo Mercado Pago, com opção de Pix ou cartão de crédito parcelado.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {[
            { n: "8", label: "Casas em administração" },
            { n: "100%", label: "Reservas diretas" },
            { n: "24 h", label: "Suporte disponível via WhatsApp" },
          ].map((s) => (
            <div key={s.label} className="bg-white border border-[#E4E4E7] rounded-md p-6">
              <div className="font-display text-4xl text-[#0AA89C]">{s.n}</div>
              <div className="text-xs uppercase tracking-[0.24em] text-[#6B7280] mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </section>
    </PublicShell>
  );
}
